import React, { FunctionComponent } from "react";
import { NoDataProps } from "./types";
import NoResults from "icons/noResults.svg";
import { Button, Container, Typography } from "components/ct-design";
import "./style.scss";
const NoData: FunctionComponent<NoDataProps> = (props) => {
  const {
    title,
    description = "",
    buttonTitle = "",
    buttonOnClick = () => {},
    Icon = <NoResults />,
    className = "",
    showIcon = true,
    marginTop = "0px",
    top = "50%",
    left = "50%",
    showTitle = false,
  } = props;

  return (
    <Container
      css={{ marginTop: marginTop }}
      className={`${className} error-message`}
      style={{
        top: top,
        left: left,
      }}
      data-testid="no-data-screen"
    >
      <div
        className="flex flex-column flex-middle flex-center  ta-center"
        style={{ height: "calc(100%-400px)", maxWidth: "400px" }}
      >
        {showIcon ? Icon : null}
        {showTitle ? (
          <Typography className="mt-4" variant="HM2">
            {title}
          </Typography>
        ) : null}
        <Typography className="mt-8 w-100p" variant="B1">
          {description}
        </Typography>
        {buttonTitle && (
          <Container className="mt-6">
            <Button
              className="h-10 mw-200 bg-neutral-900"
              color="primary"
              onClick={buttonOnClick}
            >
              {buttonTitle}
            </Button>
          </Container>
        )}
      </div>
    </Container>
  );
};

export default NoData;
